module.exports = __webpack_public_path__ + "img/icons/doc-78da9d079075b7bf8793bd8f9609d6e3.svg";